// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Server Setup

import axios from "axios";
export const http = axios.create({ baseURL: "https://v.ilab.ba/" });
export const barcode = "https://v.ilab.ba/images/barcodes/";
export const server = "https://v.ilab.ba/";
export const serverSocket = "https://v.ilab.ba/";
export const apiUrlPatients = "https://v.ilab.ba/prijem/pacijenti/";
export const apiUrlObradaPregled = "https://v.ilab.ba/obrada/pregled/";
export const apiUrlNalaziPregled = "https://v.ilab.ba/nalazi/pregled";
export const apiUrlNalaziOutbox = "https://v.ilab.ba/nalazi/outbox";
export const apiUrlLabAssays = "https://v.ilab.ba/assays/lab";
export const apiUrlAnaAssays = "https://v.ilab.ba/assays/ana";
export const apiUrlControlClone = "https://v.ilab.ba/control/clone";
export const apiUrlControlEdit = "https://v.ilab.ba/control/edit";
export const apiUrlControlResults = "https://v.ilab.ba/control/results";
export const apiUrlIntegration = "https://v.ilab.ba/api/pregled";
export const apiUrlProdukt = "https://v.ilab.ba/inventar/produkti";
export const apiUrlUgovor = "https://v.ilab.ba/inventar/ugovori";
export const apiUrlStanje = "https://v.ilab.ba/inventar/stanje";
export const apiUrlNarudzbenica = "https://v.ilab.ba/inventar/narudzbenice";
export const apiUrlUlaz = "https://v.ilab.ba/inventar/ulazpregled";
export const apiUrlIzlaz = "https://v.ilab.ba/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 114